<template>
    <div class="sidebar-spacing">
        <sidebar-item :link="{ name: $t('menus.support.support'), icon: 'live_help' }">
            <!-- for sidebar item to work properly with custom li a tags. 
            we need to trick the sidebar item to think that it has a children. 
            It will then create a ul tag that will enclose the custom li tags-->
            <sidebar-item class="hide" :link="{ active: false }" />
            <li>
                <a href="https://help.locate2u.com" target="_blank" class="nav-link first-support-link">
                    <span class="sidebar-mini">{{ $t('menus.support.knowledgeBase-mini') }}</span>
                    <span class="sidebar-normal">{{ $t('menus.support.knowledgeBase') }}</span>
                </a>
            </li>
            <li v-if="$root.isDesktop">
                <a @click="chatSupport" class="nav-link">
                    <span class="sidebar-mini">{{ $t('menus.support.chatSupport-mini') }}</span>
                    <span class="sidebar-normal">{{ $t('menus.support.chatSupport') }}</span>
                </a>
            </li>
            <sidebar-item
                v-if="user.role === 'Team Owner' || user.role === null"
                :link="{
                    name: $t('menus.support.gettingStarted'),
                    path: '/support/onboarding'
                }"
            />
        </sidebar-item>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    methods: {
        chatSupport() {
            // 1. Inject the loader once. The window.L2UChat guard handles pages
            //    that loaded the widget some other way; the id check handles
            //    subsequent calls on this same page.
            if (!window.L2UChat && !document.getElementById('l2u-chat-widget-loader')) {
                const script = document.createElement('script');
                script.id = 'l2u-chat-widget-loader';
                script.src = 'https://inside.locate2u.com/chat-widget.js';
                script.async = true;
                document.body.appendChild(script);
            }

            // 2. Once the API is available, hide the FAB, open the panel, and
            //    tear the widget out when the conversation ends.
            function wireUp() {
                window.L2UChat.hideFab();
                window.L2UChat.open();
                window.L2UChat.on('conversationClosed', () => {
                    window.L2UChat.remove();
                });
            }
            if (window.L2UChat) {
                wireUp();
            } else {
                const t = setInterval(() => {
                    if (window.L2UChat) {
                        clearInterval(t);
                        wireUp();
                    }
                }, 50);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.first-support-link {
    margin-top: 0 !important;
}
</style>
